// Staged progress copy for a lead form's submit button. The submit is a
// single POST, so the stages are keyed to elapsed time, mirroring the
// server's actual order (junk checks first, then the CRM write and
// notification email). Pair with ElementLoadingSpinner in the button and
// ElementSubmitStatus next to it so screen readers hear the stages too.
//
// Call startSendingMessages() when the request fires and stopSendingMessages()
// in the finally block. Timers are also cleared on unmount.
export const useSubmitProgress = () => {
  const sendingMessage = ref('')
  let timers = []

  const startSendingMessages = () => {
    sendingMessage.value = 'Checking your details...'
    timers = [
      setTimeout(() => { sendingMessage.value = 'Sending your request to our team...' }, 1200),
      setTimeout(() => { sendingMessage.value = 'Almost done, thanks for waiting...' }, 4500),
    ]
  }

  const stopSendingMessages = () => {
    timers.forEach(clearTimeout)
    timers = []
    sendingMessage.value = ''
  }

  onUnmounted(stopSendingMessages)

  return { sendingMessage, startSendingMessages, stopSendingMessages }
}
